module.exports = __webpack_public_path__ + "img/info-circle.b06a6019.svg";